<script>
import { mapActions } from 'vuex';
import cookie from 'cookie-machine';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'Login',
  mixins: [snackbarMixin],
  data() {

    cookie.remove('token');
    cookie.remove('roleIds');
    cookie.remove('user');

    return {
      userName: '',
      password: '',
      hasError: false,
      hasErrorForResetPassword: false,
      hasErrorForResetPasswordReqFields: false,
      isSuccessForResetPassword: false,
      isLoading: false,
    };
  },
  computed: {
    showResetPasswordButton() {
      return this.$route.query.showResetPass === 'true';
    }
  },
  methods: {
    ...mapActions('app', ['login', 'resetPassword']),
    
    async submit() {

      if(this.userName == ''){
        this.hasError = true;
        console.log('kullanıcı adı boş');
        return;
      }

      this.isLoading = true;
      this.hasError = false;
      this.hasErrorForResetPassword = false;
      this.hasErrorForResetPasswordReqFields = false;
      this.isSuccessForResetPassword = false;

      try {
        const response = await this.login({ Email: this.userName, Password: this.password });

        cookie.set('token', response.data.token, { expires: new Date(response.data.expires) });

        const canAddUser = response.data.canAddUser;
        const isKysUser = response.data.isKysUser;
        const isKysAdmin = response.data.isKysAdmin;
        const isHaveConfirmRight = response.data.isHaveConfirmRight;
        const isHaveReportRight = response.data.isHaveReportRight;
        const isHaveReportRightINS = response.data.isHaveReportRightINS;

        this.$store.commit('setCanAddUser', canAddUser);
        this.$store.commit('setIsKysUser', isKysUser);
        this.$store.commit('setIsKysAdmin', isKysAdmin);
        this.$store.commit('setIsHaveConfirmRight', isHaveConfirmRight);
        this.$store.commit('setIsHaveReportRight', isHaveReportRight);
        this.$store.commit('setIsHaveReportRightINS', isHaveReportRightINS);
        this.$store.commit('setUserEmail', this.userName);

        this.$router.push({ path: '/' });
      } catch (error) {
        console.error('Giriş hatası:', error);
        this.hasError = true;
      } finally {
        this.isLoading = false;
      }
    },
    async resetPassword2() {
      console.log('Schupy', this.userName)
      if(this.userName === null){
        this.hasErrorForResetPasswordReqFields = true;
        console.log('kullanıcı adı boş 2');
        return;
      }

      this.hasErrorForResetPassword = false;
      this.hasErrorForResetPasswordReqFields = false;
      this.hasError = false;
      this.isLoading = true;
      this.isSuccessForResetPassword = false;

      try {
        const response = await this.resetPassword({ Email: this.userName });
        if (response.data === true) {
          this.isSuccessForResetPassword = true;
          this.showSuccessMessage(`Şifre sıfırla ile ilgili yönergeler ${this.userName} mail adresinize gönderilmiştir.`);
        } else {
          this.hasErrorForResetPassword = true;
        }
      } catch (error) {
        console.error('Şifre sıfırlama hatası:', error);
        this.hasErrorForResetPassword = true;
      } finally {
        this.isLoading = false;
      }
    },
    startLoading() {
      this.isLoading = true;
    },
    stopLoading() {
      this.isLoading = false;
    }
  },
};
</script>

<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4 lg4 xl2>
          <v-card class="elevation-12">
            <v-img src="@/assets/summa.logo.png" alt="Summa"></v-img>

            <v-toolbar dark color="#B4C3C0">
              <v-toolbar-title style="font-family: Roboto, sans-serif;">
                SUMMA - OOS Giriş
              </v-toolbar-title>
              <v-spacer />
            </v-toolbar>

            <v-card-text>
              <v-form @submit.prevent="submit">
                <label for="email" class="custom-label" style="margin-left:23px; margin-top:-10px;">E-Mail</label>
                <v-text-field
                  v-model="userName"
                  id="email"
                  prepend-icon="person"
                  type="text"
                  clearable
                  autocomplete="email"
                  class="schupy-input-login"
                />
                <label for="password" class="custom-label" style="margin-left:23px; margin-top:-10px;">Şifre</label>
                <v-text-field
                  v-model="password"
                  id="password"
                  prepend-icon="lock"
                  type="password"
                  autocomplete="password"
                  class="schupy-input-login"
                  clearable
                />
                <v-btn dark color="green" type="submit" style="width: 100%;">
                  <span style="font-family: Roboto, sans-serif; font-weight: bold;">
                    {{ isLoading ? 'Giriş Yapılıyor...' : 'Giriş Yap' }}
                  </span>
                </v-btn>
              </v-form>
            </v-card-text>

            <v-card-actions style="display: block;">
              <span v-if="hasError" style="font-family: Roboto, sans-serif; color: red; width: 100%;">
                Kullanıcı adı veya parola hatalı.
                <br />
                Lütfen tekrar deneyin!
              </span>
              <v-spacer />
            </v-card-actions>

            <v-card-actions style="display: block;">
              <span v-if="hasErrorForResetPassword" style="font-family: Roboto, sans-serif; color: red; width: 100%;">
                Bir sorunla karşılaşıldı
                <br />
                Lütfen tekrar deneyin!
              </span>

              <span v-if="hasErrorForResetPasswordReqFields" style="font-family: Roboto, sans-serif; color: red; width: 100%;">
                Lütfen Email adresinizi giriniz
              </span>

              <span v-if="isSuccessForResetPassword" style="font-family: Roboto, sans-serif; color: red; width: 100%;">
                Şifre sıfırla ile ilgili yönergeler mail adresinize gönderilmiştir. Mailin size ulaşmaması durumunda gereksiz klasörünüzde olabileceğini hatırlatmak isteriz.
              </span>

              <v-btn @click="resetPassword2" color="darken-3" fat text style="font-family: Roboto, sans-serif; width: 100%;">
                Şifre yenilemek için tıklayınız
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>


<style>
.schupy-input-login {
    padding-top: 0px !important;
    margin-top: 0px !important;
}
</style>